export const Error = ({ errors, name, message = "" }) => {
  if (errors[name]) {
    return (
      <p className="mt-2 text-sm text-red-600" id="employed-error">
        {message ? message : "Answer is required."}
      </p>
    );
  }
};
